class ManageMappa {
	init() {
		const getMappaButton = document.querySelector('#get-mappa-button');
		const modal = document.querySelector('.modal-mappa');
		const modalClose = document.querySelector('.modal-close');
		getMappaButton.addEventListener('click', function () {
			modal.classList.add('is-flex');
		});
		modalClose.addEventListener('click', function () {
			modal.classList.remove('is-flex');
		});
	}
}

export default ManageMappa;
